module.exports = __webpack_public_path__ + "static/media/rio calculator.a4fb9f10.jpg";